export default __webpack_public_path__ + "static/media/p1.4f02928e.jpg";